// TODO: 중복제거
import { renderContentTypeWithComma, renderDataTypeWithComma } from "@/lib/utils/renderType";
import dayjs from "dayjs";
import { isBooksProduct } from "src/api/booksProducts";
import { CurriculumsWithString, GradesWithString, SourceTypeWithString, Subjects, SubjectsWithString } from "src/api/product";
// TODO: remove publisherName parameter
export default function getDetailInfoList(product, publisherName) {
    const { title , author  } = product;
    const source_type = isBooksProduct(product) ? product.productType : product.source_type;
    const source = isBooksProduct(product) ? product : product.source;
    const createdAt = isBooksProduct(product) ? null : product.created_at;
    const { published_at  } = source// TODO: remove type assertion
    ;
    const { genre , era , subject , based_textbook_title , unit , grade , data_type , content_type , question_number , curriculum , publisher: workPublisher  } = source// TODO: remove type assertion
    ;
    const sourceTypeValue = SourceTypeWithString[source_type];
    const subjectValue = SubjectsWithString[subject];
    const gradeValue = CurriculumsWithString[curriculum] + GradesWithString[grade];
    const dataTypeValue = renderDataTypeWithComma(data_type);
    const contentTypeValue = renderContentTypeWithComma(content_type);
    const dateFormat = (date, format)=>{
        return date ? dayjs(date).format(format) : null;
    };
    switch(source_type){
        case "handout":
            if (subject === Subjects.KO) {
                return [
                    {
                        type: "과목",
                        value: subjectValue
                    },
                    {
                        type: "학년",
                        value: gradeValue
                    },
                    {
                        type: "출처",
                        value: based_textbook_title
                    },
                    {
                        type: "제작자",
                        value: author
                    },
                    {
                        type: "자료유형",
                        value: dataTypeValue
                    },
                    {
                        type: "문항 수",
                        value: Number(question_number)
                    },
                    {
                        type: "등록일자",
                        value: dateFormat(createdAt, "YYYY년 MM월 DD일")
                    }
                ];
            }
            return [
                {
                    type: "과목",
                    value: subjectValue
                },
                {
                    type: "학년",
                    value: gradeValue
                },
                {
                    type: "출처",
                    value: based_textbook_title
                },
                {
                    type: "단원",
                    value: unit
                },
                {
                    type: "제작자",
                    value: author
                },
                {
                    type: "자료유형",
                    value: dataTypeValue
                },
                {
                    type: "문항 수",
                    value: Number(question_number)
                },
                {
                    type: "등록일자",
                    value: dateFormat(createdAt, "YYYY년 MM월 DD일")
                }
            ];
        case "textbook":
        case "workbook":
            return [
                {
                    type: "상품 유형",
                    value: sourceTypeValue
                },
                {
                    type: "과목",
                    value: subjectValue
                },
                {
                    type: "교재명",
                    value: title
                },
                {
                    type: "대표저자",
                    value: author
                },
                {
                    type: "출판사명",
                    value: publisherName
                },
                {
                    type: "학년",
                    value: gradeValue
                },
                {
                    type: "출간년도",
                    value: dateFormat(published_at, "YYYY년")
                }
            ];
        case "work":
            return [
                {
                    type: "상품유형",
                    value: sourceTypeValue
                },
                {
                    type: "과목",
                    value: subjectValue
                },
                {
                    type: "제목",
                    value: title
                },
                {
                    type: "글쓴이",
                    value: author
                },
                {
                    type: "저작권자",
                    value: workPublisher
                },
                {
                    type: "장르",
                    value: genre
                },
                {
                    type: "시대",
                    value: era
                }
            ];
        default:
            // 상품 유형, 과목, 교재명, 대표저자, 출판사명, 학년, 출간년도, ISBN
            if (!isBooksProduct(product)) return [];
            return [
                {
                    type: "상품 유형",
                    value: sourceTypeValue
                },
                {
                    type: "과목",
                    value: subjectValue
                },
                {
                    type: "교재명",
                    value: title
                },
                {
                    type: "대표저자",
                    value: author
                },
                {
                    type: "출판사명",
                    value: publisherName
                },
                {
                    type: "학년",
                    value: CurriculumsWithString[product.curriculum] + " " + product.grades.map((grade)=>GradesWithString[grade]).join(", ")
                },
                {
                    type: "출간년도",
                    value: dateFormat(published_at, "YYYY년")
                },
                {
                    type: "ISBN",
                    value: product.isbn13
                }
            ];
    }
}
